module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"billingDetails.title":"Billing details"}}')
  delete Component.options._Ctor
}
